import { MsalProvider } from "@azure/msal-react";
import { ChakraProvider } from "@chakra-ui/react";
import "@fontsource/inter/100.css"; //thin
import "@fontsource/inter/200.css"; //extra-light
import "@fontsource/inter/300.css"; //light
import "@fontsource/inter/400.css"; //regular
import "@fontsource/inter/500.css"; //medium
import "@fontsource/inter/600.css"; //semibold
import "@fontsource/inter/700.css"; //bold
import "@fontsource/inter/800.css"; //extra-bold
import "@fontsource/inter/900.css"; //black
import * as Sentry from "@sentry/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { msalInstance } from "lib/msal";
import { queryClient } from "lib/query-client";
import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import router from "router/router";
import theme from "theme/theme";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  sendDefaultPii: true,
  enabled: import.meta.env.MODE === "production",
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true, // mascara textos (ex.: inputs de senha)
      blockAllMedia: true, // bloqueia vídeos/áudios
    }),
  ],
  replaysSessionSampleRate: 0.01, // grava 10% das sessões
  replaysOnErrorSampleRate: 1.0, // grava 100% quando há erro
  tracesSampleRate: 0.2, // 20% das transações serão enviadas
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <QueryClientProvider client={queryClient}>
        <ChakraProvider theme={theme}>
          <RouterProvider router={router} />
        </ChakraProvider>
      </QueryClientProvider>
    </MsalProvider>
  </React.StrictMode>
);
